






























import Vue from "vue";
import { productCampageApi } from "@/core/api";

export default Vue.extend({
  name: "CampaignTest",
  data() {
    return {
      item: null,
      deg: 0,
      n: 0,
      gift: 0,
      showGift: false,
      loading: false,
      done: false
    };
  },
  methods: {
    handleResatart() {
      this.deg = 0;
      this.loading = true;
      setTimeout(() => {
        this.showGift = false;
      }, 2000);
    },
    handleStart() {
      this.loading = false;
      let n;
      const a = Math.floor(Math.random() * 360 + 1);
      const giftIndex = Math.floor(a / 60);
      this.gift = this.item.gifts[giftIndex];
      this.deg = -(a + 360 * 5);
      setTimeout(() => {
        this.showGift = true;
      }, 1000);
    }
  },
  async created() {
    const id = this.$route.params.id;
    const item = await productCampageApi.getItem(id);
    this.item = item;
  }
});
